import { render, staticRenderFns } from "./newsletter-signup.vue?vue&type=template&id=152ade25&scoped=true"
import script from "./newsletter-signup.vue?vue&type=script&lang=js"
export * from "./newsletter-signup.vue?vue&type=script&lang=js"
import style0 from "./newsletter-signup.vue?vue&type=style&index=0&id=152ade25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152ade25",
  null
  
)

export default component.exports